import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-22e20d18"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "advertise_wrapper"
};
const _hoisted_2 = {
  class: "advertise_top"
};
const _hoisted_3 = {
  class: "advertise_top_title"
};
const _hoisted_4 = {
  class: "advertise_top_des"
};
const _hoisted_5 = {
  href: "#AdvertiseCommunity",
  class: "anchor_wrapper"
};
const _hoisted_6 = {
  class: "advertise_top_btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AdvertiseIntroduction = _resolveComponent("AdvertiseIntroduction");
  const _component_IntroductionDetail = _resolveComponent("IntroductionDetail");
  const _component_CommunitySeeking = _resolveComponent("CommunitySeeking");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("MarketingLinkr")), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("MarketingLinkrDes")), 1), _createElementVNode("a", _hoisted_5, [_createElementVNode("button", _hoisted_6, _toDisplayString(_ctx.$t("GetInfluencer")), 1)])]), _createVNode(_component_AdvertiseIntroduction), _createVNode(_component_IntroductionDetail), _createVNode(_component_CommunitySeeking, {
    class: "advertise_community"
  })]);
}